import React from 'react';
import { cn } from 'utils';

interface CustomBadgeProps {
  label: string;
  backgroundColor?: string;
  textColor?: string;
  onClick?: () => void;
}

const CustomBadge: React.FC<CustomBadgeProps> = ({
  label,
  backgroundColor,
  textColor,
  onClick,
}) => {
  const defaultColors = {
    bg: 'bg-green-100',
    text: 'text-green-600',
  };

  return (
    <div
      className={cn('flex items-center h-full', onClick && 'cursor-pointer')}
      onClick={onClick}
    >
      <span
        className={cn(
          'inline-flex items-center gap-2 px-3 py-1 rounded-md text-sm font-medium',
          backgroundColor || defaultColors.bg,
          textColor || defaultColors.text
        )}
      >
        {label}
      </span>
    </div>
  );
};

export default CustomBadge;
